import { TemplatePermessoPerGruppoOrganizzativo } from './template-permesso-gruppo-organizzativo';
import { TemplateProfilo } from './template-profilo';

export class TemplateUtenteProfilo {
   id: string;
   label: string;
   sistema: boolean;
   templateProfiloGruppiOperativi: TemplateProfilo[] = [];
   templateProfiloGruppiOrganizzativi: TemplateProfilo[] = [];
   templateProfiloGruppiVisibilita: TemplateProfilo[] = [];
   templateProfiloRuoli: TemplateProfilo[] = [];
   templateProfiloPermessi: TemplateProfilo[] = [];
   templateProfiloGruppiSpeciali: TemplateProfilo[] = [];
   permessiPerGruppoOrganizzativo: TemplatePermessoPerGruppoOrganizzativo[] = [];
}
